export const BREADCRUMBS_PAGE_TEXT = {
  LANDING: 'Education & Career Plan',
  RECOMMENDER_WORKSPACE: 'Education and career planning',
  WELCOME_PAGE: 'Welcome Page',
};
